module.exports = __webpack_public_path__ + "img/button-home5.adc6eba7.png";